import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const ExpertiseCard = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { inc_knowhow, showExperienceDuration, inc_keyexpertise, inc_showroles, inc_keyroles } = state

  return (
    <CVCard
      title={t('CVTemplates.Expertise')}
      description={t('CVTemplates.ExpertiseAndRoles')}
      isEnabled={inc_knowhow}
      toggleName='inc_knowhow'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='inc_keyexpertise'
          label={t('CVTemplates.KeyExpertiseOnly')}
          value={inc_keyexpertise}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_showroles' label={t('CVTemplates.ShowRoles')} value={inc_showroles} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_keyroles' label={t('CVTemplates.KeyRolesOnly')} value={inc_keyroles} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='showExperienceDuration'
          label={t('CVTemplates.ShowExperienceDuration')}
          value={showExperienceDuration}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
